export const formatToCurrency = (data, currency = 'USD') => {
  if (!data) {
    return ''
  }
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: 0
  })
  return formatter.format(data)
}

const removeChar = (str, target) => {
  const re = new RegExp(target, 'g')
  return str.replace(re, '')
}

export const getAmount = line => {
  const parts = line.trim().split(' ')
  if (parts.length === 3) {
    const amount = removeChar(parts[1], ',')
    return amount
  }
  return ''
}

export default {
  formatToCurrency,
  getAmount
}
